<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard>
          <FixedCostAreaDetails
            @submitted="submitted"
            :loading="loading"
          >Fixed Cost #{{$route.params.id}}</FixedCostAreaDetails>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import FixedCostAreaDetails from "@/components/settings/pricing/FixedCostAreaDetails.vue";
import FixedCostDetails from "@/components/settings/pricing/FixedCostDetails.vue";
import FixedCostCustomerList from "@/components/settings/pricing/FixedCostCustomerList.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    FixedCostAreaDetails,
    FixedCostDetails,
    FixedCostCustomerList,
    SimpleCard
  },
  data: function() {
    return {
      loading: false
    };
  },
  mounted: async function() {},
  methods: {
    success: function(data) {
      this.$router.push("/settings/pricing/fixed_cost/" + data.fixed_cost.id);
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    },
    submitted: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/fixed_cost/create`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            completed(res.data);
          } else {
            failed(res.data.error);
          }
        })
        .catch(function(err) {
          failed("internal_server_error");
          console.error(err);
        });
    }
  }
};
</script>
